export * from './Notification';
export default from './Notification';


// WEBPACK FOOTER //
// ./src/components/common/Notification/index.js